export default __webpack_public_path__ + "static/bg-header3-6c5326aae4dd82285eba4c63960d042f.jpg";